import React from "react"

const KeyFeatures = () => {
  return <div>key features</div>
}

export default KeyFeatures
